<template>
  <layout-component>
    <div class="banner banner-dashboard">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
          </div>
          </div>
      </div>
    </div>
    <div class="container form pb-4">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <b-alert :show="$store.user && !$store.user.email_verified_at" fade variant="danger">
              <h4><i class="fal fa-times"></i>{{'email-not-verified'|t}}</h4>
              <button class="btn btn-primary" @click="resendEmail()"><span>{{'email-resend'|t}}</span></button>
          </b-alert>
          <b-alert :show="success" fade variant="success">
            <h4><i class="fal fa-check"></i>{{'success-title-01'|t}}</h4>
            <p>{{'success-text-01'|t}}</p>
          </b-alert>
          <b-alert :show="has_error && !success" fade variant="danger">
            <template v-if="error == 'registration_validation_error'">
              <h4><i class="fal fa-times"></i>{{'error-title-01'|t}}</h4>
              <p>{{'error-text-01'|t}}</p>
            </template>
            <template v-else>
              <h4><i class="fal fa-times"></i>{{'error-title-02'|t}}</h4>
              <p>{{'error-text-02'|t}}</p>
            </template>
          </b-alert>

          <form autocomplete="off" @submit.prevent="update" v-if="user" method="post">
            <h3>{{ 'title-01' | t }}</h3>
            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.name }">
                  <label for="register-name">{{'label-firstname'|t}} <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-name" class="form-control" placeholder="Peter" v-model="user.name">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.name" v-html="errors.name.join('<br />')"></small>
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.surname }">
                  <label for="register-surname">{{'label-lastname'|t}} <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-surname" class="form-control" placeholder="Parker" v-model="user.surname">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.surname" v-html="errors.surname.join('<br />')"></small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.email }">
                  <label for="register-email">{{'label-email'|t}} <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="email" id="register-email" class="form-control" placeholder="user@example.com" v-model="user.email">
                    <span class="focus-border"></span>
                  </div>
                    <small class="form-text text-danger" v-if="has_error && errors.email" v-html="errors.email.join('<br />')"></small>
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.email }">
                  <label for="register-email_confirmation">{{'label-email-confirmation'|t}} <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="email" id="register-email_confirmation" class="form-control" placeholder="user@example.com" v-model="user.email_confirmation">
                    <span class="focus-border"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group" :class="{ 'has-error': has_error && errors.phone }">
                  <label for="register-phone">{{'label-phone-number'|t}} <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-phone" class="form-control" placeholder="+352 123456789" v-model="user.phone">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.phone" v-html="errors.phone.join('<br />')"></small>
                </div>
              </div>
            </div>

            <h3>{{ 'title-02' | t }}</h3>
            <p>{{ 'text-password' | t }}</p>
            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                    <label for="register-password">{{'label-password'|t}} <span class="required">*</span></label>
                    <div class="input-wrapper">
                      <input type="password" id="register-password" class="form-control" v-model="user.password" autoComplete="true">
                      <span class="focus-border"></span>
                    </div>
                    <small class="form-text text-danger" v-if="has_error && errors.password" v-html="errors.password.join('<br />')"></small>
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                    <label for="register-password_confirmation">{{'label-password-confirmation'|t}} <span class="required">*</span></label>
                    <div class="input-wrapper">
                      <input type="password" id="register-password_confirmation" class="form-control" v-model="user.password_confirmation" autoComplete="true">
                      <span class="focus-border"></span>
                    </div>
                </div>
              </div>
            </div>

            <h3>{{ 'title-03' | t }}</h3>
            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.company }">
                  <label for="register-company">{{'label-company-name'|t}} <em v-if="!user.company">{{'label-optional'|t}}</em></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-company" class="form-control" placeholder="Daily Bugle" v-model="user.company">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.company" v-html="errors.company.join('<br />')"></small>
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.vat }">
                  <label for="register-vat">{{'label-vat-number'|t}} <em v-if="!user.company">{{'label-optional'|t}}</em></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-vat" class="form-control" placeholder="LU12345678" v-model="user.vat">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.vat" v-html="errors.vat.join('<br />')"></small>
                </div>
              </div>
            </div>

            <h3>{{ 'title-04' | t }}</h3>
            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.address }">
                  <label for="register-address">{{'label-address'|t}} <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-address" class="form-control" placeholder="115c, rue Emile Mark" v-model="user.address">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.address" v-html="errors.address.join('<br />')"></small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.address2 }">
                  <label for="register-address2">Address supplement <em>(Optional)</em></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-address2" class="form-control" v-model="user.address2">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.address2" v-html="errors.address2.join('<br />')"></small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.postcode }">
                  <label for="register-postcode">Postcode <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-postcode" class="form-control" placeholder="4620" v-model="user.postcode">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.postcode" v-html="errors.postcode.join('<br />')"></small>
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group" :class="{ 'has-error': has_error && errors.city }">
                  <label for="register-city">City <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input type="text" id="register-city" class="form-control" placeholder="Differdange" v-model="user.city">
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.city" v-html="errors.city.join('<br />')"></small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group" :class="{ 'has-error': has_error && errors.countrycode }">
                  <label for="register-countrycode">Country <span class="required">*</span></label>
                  <div class="select-wrapper">
                    <b-form-select id="register-countrycode" v-model="user.countrycode" :options="countrycodes" :plain="true" />
                    <span class="focus-border"></span>
                  </div>
                  <small class="form-text text-danger" v-if="has_error && errors.countrycode" v-html="errors.countrycode.join('<br />')"></small>
                </div>
              </div>
            </div>

            <button type="submit" class="btn btn-primary btn-submit"><span>{{'submit-btn'|t}}</span></button>
          </form>
        </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        user: null,
        countrycodes: [],
        has_error: false,
        error: '',
        errors: {},
        success: false
      }
    },
    mounted() {
      this.countrycodes = this.$store.countryCodes
      this.user = this.$auth.user()
      this.user.email_confirmation = this.user.email
    },
    methods: {
      update() {
        var data = this.user
        Vue.axios.post('/auth/update', data)
        .then(res => {
          this.success = true
          this.has_error = false
          setTimeout(function(){
            animateScrollTo(document.querySelector('.alert'), {
              offset: -200,
              passive: true
            });
          }, 50);
        })
        .catch(error => {
          this.has_error = true
          this.success = false
          this.error = error.response.data.error
          this.errors = error.response.data.errors || {}
          setTimeout(function(){
            animateScrollTo(document.querySelector('.alert'), {
              offset: -200,
              passive: true
            });
          }, 50);
        })
      },
      resendEmail() {
        Vue.axios.get('/email/resend', this.$store.user.id)
        .then(res => {
          // console.log(res)
        })
        .catch(error => {
          // console.log(error)
        })
      }
    }
  }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>My Profile</span></span>",
        "bookings": "Bookings",
        "profile": "Profile",
        "success-title-01": "Great news",
        "success-text-01": "Your profile has been updated.",
        "error-title-01": "Validation error",
        "error-text-01": "Please see below. ",
        "error-title-02": "Error.",
        "error-text-02": "Unable to update your profile for now. Please try again later or contact us.",
        "subtitle-01": "Edit your profile",
        "title-01": "Who you are",
        "title-02": "Your password",
        "title-03": "Where you work",
        "title-04": "Where you live",
        "text-password": "Please leave the fields blank unless you want to change your password",
        "label-firstname": "First name",
        "label-lastname": "Last name",
        "label-email": "Email",
        "label-email-confirmation": "Email confirmation",
        "label-optional": "(optional)",
        "label-phone-number": "Phone number",
        "label-password": "Password",
        "label-password-confirmation": "Password confirmation",
        "label-company-name": "Organisation",
        "label-vat-number": "VAT number",
        "label-address": "Address",
        "label-address-supplement": "Address supplement",
        "label-postcode": "Postcode",
        "label-city": "City",
        "label-country": "Country",
        "submit-btn": "Save",
        "email-not-verified": "Please go to your mailbox to confirm your account",
        "email-resend": "Resend email"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Mon Profil</span></span>",
        "bookings": "Reservations",
        "profile": "Profil",
        "success-title-01": "Bonne nouvelle",
        "success-text-01": "Votre profil a été mis à jour.",
        "error-title-01": "Erreur de validation",
        "error-text-01": "Voir ci-dessous. ",
        "error-title-02": "Erreur.",
        "error-text-02": "La mise à jour de votre profil est impossible pour l’instant. Veuillez réessayer plus tard ou nous contacter.",
        "subtitle-01": "Modifier votre profil",
        "title-01": "Qui vous etes",
        "title-02": "Votre mot de passe",
        "title-03": "Ou vous travaillez",
        "title-04": "Ou vous habitez",
        "text-password": "Veuillez laisser ces champs vierges, sauf si vous souhaitez modifier votre mot de passe.",
        "label-firstname": "Prénom",
        "label-lastname": "Nom",
        "label-email": "Adresse email",
        "label-email-confirmation": "Confirmation de l’adresse email",
        "label-optional": "(facultatif)",
        "label-phone-number": "Numéro de téléphone",
        "label-password": "Mot de passe",
        "label-password-confirmation": "Confirmation du mot de passe",
        "label-company-name": "Société",
        "label-vat-number": "Numéro de TVA",
        "label-address": "Adresse postale",
        "label-address-supplement": "Complément d’adresse postale",
        "label-postcode": "Code postal",
        "label-city": "Ville",
        "label-country": "Pays",
        "submit-btn": "Enregistrer",
        "email-not-verified": "Veuillez consulter votre boite mail pour confirmer votre compte",
        "email-resend": "Renvoyer l'email"
      }
    }

  </i18n>
